/* eslint-disable */

import jQuery from 'jquery';
import moment from 'moment';
import { mapState, mapGetters } from 'vuex'



export default {

  data: function () {
    return {
      winners: [],

    }
  },
  methods: {
    showWinners: function(){

      let self = this;

      let payload = {
        action: 'getWinners',
        access_token: this.accessToken,
        contest_code: this.contestData.code,

      };

      this.loading = true;
      self.show_winner = true;
      self.modal.show = false;
      this.callApi( payload,  function( response){
        self.loading = false;
        self.show_winner = false;

        if(!response.success){
          self.showError(response.data);
        }
        else if(response.data != undefined){

          self.winners = response.data;
          self.modal.state = 'winners';
          self.modal.show = true;

        }

      } );


    },

    gotoNextContest: function(){

      var contests = this.contestData.contests;

      contests.sort( function(a, b) {

        a.is_default = a.hasDefaultRule ? 1 : 0;
        b.is_default = b.hasDefaultRule ? 1 : 0;

        if(a.is_default == b.is_default){
          return a.level - b.level;
        }
        else{
          return b.is_default - a.is_default;
        }


      });

      if(  contests && contests[ this.next_contest_index ] != undefined ){
        this.current_contest = contests[ this.next_contest_index ];

        this.next_contest_index++;
      }

      if( this.current_contest.attemptsLeft )
        this.attempts_left = this.current_contest.attemptsLeft;

      if( this.current_contest.attempts )
        this.attempts_done = this.current_contest.attempts;

    },



  },
  computed: {
    current_contest_rewards_name: function(){

      if(this.current_contest.rewards != undefined && this.current_contest.rewards.length > 0){
        return _.map(this.current_contest.rewards, function( item ){ return item.title; }).join('<br>');
      }
      else return null;
    },

    current_contest_rewards_name_short: function(){

      var name = '';
      var rewards = [];

      for( var i in this.contestData.contests){
        var contest = this.contestData.contests[i];

        for(var j in contest.rewards){
          rewards.push(contest.rewards[j]);
        }
      }

      if( rewards.length > 1)
        name = 'i nostri premi';
      else
        name = rewards[0].title;

      return name;

    },

    play_data_rewards_name: function(){
      if(this.play_data.rewards != undefined && this.play_data.rewards.length > 0){
        return _.map(this.play_data.rewards, function( item ){ return item.reward.title; }).join('<br>');
      }
      else return null;
    },

    legal_notes: function(){
      if( this.contestData.legalNotes ){
        return this.contestData.legalNotes;
      }
      else if( this.contestData.extra && this.contestData.extra.legal_notice ){
        return this.contestData.extra.legal_notice;
      }
      else return null;
    },

  },
  mounted: () =>{

  },
}
